import { Injectable } from '@angular/core';

import { TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';

export enum QuickDepositTracking {
    NotApplicable = 'not applicable',
    Cashier = 'Cashier',
}

@Injectable()
export class QuickDepositTrackingService {
    constructor(private trackingService: TrackingService) {}

    trackClose(page: string, location: string): void {
        this.trackingService.track(trackingConstants.EVENT_TRACKING, {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: QuickDepositTracking.Cashier,
            [trackingConstants.COMPONENT_LABEL_EVENT]: page,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: location,
            [trackingConstants.COMPONENT_ACTION_EVENT]: `${page} Aborted`,
            [trackingConstants.COMPONENT_POSITION_EVENT]: QuickDepositTracking.NotApplicable,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: QuickDepositTracking.NotApplicable,
            [trackingConstants.COMPONENT_URL_CLICKED]: QuickDepositTracking.NotApplicable,
        });
    }
}
